import type { FormInstance } from 'antd/es/form';
import { message } from 'antd';

type FormValidationError = {
  errorFields?: Array<{ name?: unknown; errors?: string[] }>;
};

/**
 * Specialty (and other) book forms use many `noStyle` Form.Items, so Ant Design
 * field errors are easy to miss. Surface the first validation message in a toast
 * and scroll to that field instead of a generic "fill required fields" warning.
 */
export function warnFirstFormValidationError(
  form: FormInstance,
  err: unknown,
  fallback = 'Please fill in all required fields.'
): void {
  const errorFields = (err as FormValidationError)?.errorFields;
  const first = errorFields?.find(
    (field) => Array.isArray(field.errors) && field.errors[0]
  );
  const detail = first?.errors?.[0];
  message.warning(
    typeof detail === 'string' && detail.trim() ? detail : fallback
  );
  if (Array.isArray(first?.name) && first.name.length) {
    form.scrollToField(first.name as Array<string | number>);
  }
}
